// extracted by mini-css-extract-plugin
export default {"wrapper":"AdvtFullSize_wrapper__a6Ig8","logo":"AdvtFullSize_logo__1mlj0","titleBlock":"AdvtFullSize_titleBlock__h+dx-","title":"AdvtFullSize_title__Dj3iF"};